import { siteApiSlice } from "../../app/siteApiSlice";

export const termsOfServiceApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		agreeToTerms: build.mutation<void, void>({
			query: () => ({
				url: `/TermsOfService/Index`,
				method: "POST",
			}),
		}),
	}),
});

export const { useAgreeToTermsMutation } = termsOfServiceApiSlice;
